import { useTranslation } from "react-i18next";

import Modal from "../../../components/base/Modal";
import { Button } from "../../../components/ui";

export interface ConfirmDeleteModalProps {
  title: string;
  name: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteModal({
  title,
  name,
  onClose,
  onConfirm,
}: ConfirmDeleteModalProps) {
  const { t } = useTranslation("common");

  return (
    <Modal
      title={title}
      onClose={onClose}
      width="w-full max-w-md"
      content={
        <div className="space-y-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-error/30 bg-error/10">
              <i className="ri-delete-bin-line text-lg text-error" />
            </span>
            <p className="text-xs text-content-secondary">
              {t("monitoreoIa.actionsCommon.deleteWarning")}
            </p>
          </div>

          <p className="text-[13px] text-content-secondary">
            {t("monitoreoIa.actionsCommon.deleteQuestion")}{" "}
            <span className="font-semibold text-content">{name}</span>?
          </p>

          <div className="flex gap-3">
            <Button variant="secondary" fullWidth shape="pill" onClick={onClose}>
              {t("monitoreoIa.actionsCommon.cancel")}
            </Button>
            <Button variant="danger" fullWidth shape="pill" onClick={onConfirm}>
              {t("monitoreoIa.actionsCommon.delete")}
            </Button>
          </div>
        </div>
      }
    />
  );
}
